import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'role-config-v1',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const component = require('./RoleConfig').default
      callback(null, component)
    }, 'RoleConfig')
  }
})



// WEBPACK FOOTER //
// ./src/routes/rule-ui-routes/RoleConfig/index.js